var map = {
	"./404.svg": "8a81",
	"./brands/american express.svg": "d0e4",
	"./brands/default.svg": "a6ca",
	"./brands/elcart.svg": "9bb5",
	"./brands/kortimilli.svg": "dc4d",
	"./brands/maestro.svg": "d779",
	"./brands/mastercard.svg": "9113",
	"./brands/mir.svg": "6c75",
	"./brands/unionpay.svg": "45ba",
	"./brands/visa.svg": "270b",
	"./done.svg": "2e1f",
	"./error.svg": "2ee5",
	"./link.svg": "6bb3",
	"./oops.svg": "8105",
	"./unknown.svg": "2668"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31e8";